import { useRef, useState } from 'react'
import { useSetState } from 'ahooks'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { SActionBtn, SBack, SDrawerOrModal, SLowcodeList, STableActions } from 'shj-components'

import { config } from './config.tsx'
// import { StandardTable } from '../standard/index.tsx'
import styles from '@/pages/baseProduct/packageTemplate/addOrEdit/index.module.less'
import { AddOrEditProject } from '@/pages/baseProduct/subItemManage/addOrEdit/step2/addOrEdit/project.tsx'
import { getSubPackTreeTempTree } from '@/services/product.ts'
import { AddOrEditGeneral } from '@/pages/baseProduct/subItemManage/addOrEdit/step2/addOrEdit/general.tsx'
import { AddOrEditProduct } from '../addOrEdit/step2/addOrEdit/product.tsx'
import ExtraModal from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3/addOrEdit/extra.tsx'
import StandardDetail from '@/pages/baseProduct/generalManage/addOrEdit/index.tsx'

import { httpOrgList } from '@/services/homeService.ts'

export const SubItemDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [search] = useSearchParams()
  const packId = search.get('packId')
  const cacheId = search.get('cacheId')
  const listRef = useRef()
  const editRef = useRef()

  const [extraConfigChooseBustype, setExtraConfigChooseBustype]  = useState('')
  const [editExtraConfig, setEditExtraConfig] = useState<Array<any>>([])
  const [editExtraConfigRecord, setEditExtraConfigRecord] = useState({})
  const [openExtraConfigModal, setOpenExtraConfigModal] = useState(false);

  const [state, setState] = useSetState({
    visible: false,
    type: 'PRD_PROJECT',
    record: {},
    genItemId: '',
    companyList: [],
    treeNodes: [],
    isStandDrawer: false,
  })

  const handleOpenExtraConfigModal = (record: any, busType: any) => {
    // 要把通项本身配置带进去，同时记录原有数据
    setEditExtraConfigRecord(record);
    setEditExtraConfig(record.customizes || []);
    setOpenExtraConfigModal(true);
    setExtraConfigChooseBustype(busType);
  }

  const fetchList = () => {
    if (!id) return Promise.reject()
    return new Promise((resolve, reject) => {
      getSubPackTreeTempTree({ subItemId: id, searchFlag: true })
        .then(res => {
          setState({ treeNodes: res.treeNodes })
          return resolve({ records: res.treeNodes })
        })
        .catch(reject)
    })
  }

  const onAddOrEdit = record => {
    setState({ visible: true, type: record.busType, record: { ...record } })
  }

  const getOptions = async () => {
    const companyList = await httpOrgList()
    setState({ companyList })
  }

  // 跳转标配页面
  const clickToStandardPage = record => {
    console.log(record)
    // 手动添加
    if (record.object?.sonChooseType === 'GEN_STANDARD') {
      window.open(
        `/config/baseProduct/generalManage/standard-feature/${record.object?.id}?readOnly=true&&itemName=${record.dtlName}&&specialCode=${record.object?.specialCode}`
      )
    } else {
      // 规则配置
      setState({ visible: true, type: 'standard', record: { ...record }, isStandDrawer: true })
    }
  }

  const extensions = {
    request: { fetchList, getOptions },
    customRender: {
      jsonRender(_, record) {
        console.log(record)
        return <div>{record.shopList.map(item => item.companyName).join('、')}</div>
      },
      actionRender(_: string, record) {
        const showExtraConfig = record.busType === 'PRD_GEN_ITEM' || record.busType === 'PRD_PRODUCT';
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit(record)}>详情</SActionBtn>
            {record?.busType === 'PRD_GEN_ITEM' && (
              <SActionBtn onClick={() => clickToStandardPage(record)}>标配</SActionBtn>
            )}
            {
              showExtraConfig ? (
                <STableActions.SActionBtn onClick={() => handleOpenExtraConfigModal(record, record.busType)}>
                  特殊配置
                </STableActions.SActionBtn>
              ) : null
            }
          </STableActions>
        )
      },
    },
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const goBack = () => {
    if (packId || cacheId)
      navigate(
        `/config/baseProduct/packageTemplate/addOrEdit/${packId}?step=2&cacheId=${cacheId}`,
        { replace: true }
      )
    else {
      history.back()
    }
  }

  const modalObj = {
    PRD_PROJECT: {
      title: '项目',
      modalTitle: '项目详情',
      component: (
        <AddOrEditProject
          readOnly={true}
          {...state}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onCancel}
        />
      ),
    },
    PRD_GEN_ITEM: {
      title: '通项',
      modalTitle: '通项详情',
      component: (
        <AddOrEditGeneral
          readOnly={true}
          {...state}
          treeNodes={state.treeNodes}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onCancel}
        />
      ),
    },
    PRD_PRODUCT: {
      title: '产品',
      modalTitle: '产品详情',
      component: (
        <AddOrEditProduct
          readOnly={true}
          {...state}
          treeNodes={state.treeNodes}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onCancel}
        />
      ),
    },
    standard: {
      title: '标配',
      modalTitle: '标配详情',
      component: (
        <StandardDetail
          editRef={editRef.current}
          onCancel={onCancel}
          isStand={state.isStandDrawer}
          fn={listRef.current?.reload}
          readOnly={true}
          // setLoading={loading => setState({ loading })}
          record={state.record.object}
        />
      ),
    },
  }

  return (
    <SBack level={2} title={'子项详情'} goPath={goBack}>
      <div className={styles.container}>
        <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
        <SDrawerOrModal
          title={modalObj[state.type].modalTitle}
          width={modalObj[state.type].modalWidth || 600}
          antdProps={{ footer: null }}
          open={state.visible}
          onOk={onSubmit}
          onCancel={onCancel}
        >
          {state.visible && modalObj[state.type].component}
        </SDrawerOrModal>
        {openExtraConfigModal && <ExtraModal
          openModal={openExtraConfigModal}
          chooseType={extraConfigChooseBustype}
          editData={editExtraConfig}
          basicInfo={editExtraConfigRecord}
          setEditData={setEditExtraConfig}
          onClose={() => setOpenExtraConfigModal(false)}
          isDetail={true}
      />}
      </div>
    </SBack>
  )
}
